module.exports = __webpack_public_path__ + "static/media/template2.a2dfa08e.svg";